module.exports = __webpack_public_path__ + "img/taocan-detail-img.2b61f4f4.png";